if (!customElements.get('related-recipes')) {
  class RelatedRecipes extends HTMLElement {
    connectedCallback() {
      this.bindScrollRevealRefresh();
      this.scheduleSliderInit();
    }

    bindScrollRevealRefresh() {
      if (!this.classList.contains('scroll-trigger')) return;

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        window.setTimeout(() => this.refreshSlider(), 0);
        window.setTimeout(() => this.refreshSlider(), 150);
        window.setTimeout(() => this.refreshSlider(), 400);
      });

      observer.observe(this);
    }

    scheduleSliderInit() {
      const attempt = () => this.initSlider();

      if (attempt()) return;

      let tries = 0;
      const timer = window.setInterval(() => {
        if (attempt() || ++tries >= 40) {
          window.clearInterval(timer);
        }
      }, 100);

      window.addEventListener(
        'load',
        () => {
          attempt();
          this.refreshSlider();
        },
        { once: true }
      );
    }

    buildSlickOptions(slideCount) {
      const cap = (count) => Math.min(count, slideCount);

      const desktop = cap(4);
      const tablet = cap(3);
      const mobile = cap(2);
      const narrow = cap(1);

      return {
        slidesToShow: desktop,
        slidesToScroll: 1,
        infinite: slideCount > desktop,
        dots: false,
        focusOnSelect: slideCount > 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: tablet,
              slidesToScroll: Math.min(3, tablet),
              infinite: slideCount > tablet,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: mobile,
              slidesToScroll: Math.min(2, mobile),
              infinite: slideCount > mobile,
            },
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: narrow,
              slidesToScroll: 1,
              infinite: slideCount > narrow,
            },
          },
        ],
      };
    }

    initSlider() {
      const grid = this.querySelector('.related-recipe-grid');
      if (!grid || typeof jQuery === 'undefined' || !jQuery.fn?.slick) return false;

      const $grid = jQuery(grid);
      if ($grid.hasClass('slick-initialized')) {
        this.refreshSlider();
        return true;
      }

      const slideCount = $grid.children().length;
      if (slideCount < 1) return false;

      $grid
        .off('init.relatedRecipes')
        .on('init.relatedRecipes', () => {
          window.setTimeout(() => this.refreshSlider(), 0);
          window.setTimeout(() => this.refreshSlider(), 120);
        });

      $grid.slick(this.buildSlickOptions(slideCount));
      return true;
    }

    refreshSlider() {
      const grid = this.querySelector('.related-recipe-grid');
      if (!grid || typeof jQuery === 'undefined' || !jQuery.fn?.slick) return;

      const $grid = jQuery(grid);
      if (!$grid.hasClass('slick-initialized')) return;

      $grid.slick('setPosition');
      jQuery(window).trigger('resize');
    }
  }

  customElements.define('related-recipes', RelatedRecipes);

  window.initRelatedRecipeSliders = function initRelatedRecipeSliders(root = document) {
    root.querySelectorAll('related-recipes').forEach((element) => {
      if (typeof element.initSlider === 'function') {
        element.initSlider();
        element.refreshSlider();
      }
    });
  };
}
